// extracted by mini-css-extract-plugin
export default {"flex-column":"viewImage_flex-column__Sm86q","flex-row":"viewImage_flex-row__758rl","page-size":"viewImage_page-size__jyadJ","view-image-img":"viewImage_view-image-img__s4Icl"};